export default {"src":"/_next/static/media/beach-volleyball.113257f2.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};